import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

export default function SprintDetailsCard({
  startLabel,
  endLabel,
  endChipLabel,
  visionTitle,
  renewLabel,
  canRenew,
  canClose,
  onRenew,
  onClose,
  onDisconnect,
  onBlock,
  onManageSprint,
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "8px",
        borderColor: "#dde6ef",
        boxShadow: "0 16px 32px rgba(15, 23, 42, 0.05)",
        overflow: "hidden",
      }}
    >
      <Accordion
        disableGutters
        elevation={0}
        sx={{
          bgcolor: "transparent",
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: "1rem", fontWeight: 800, color: "#102033" }}>
              Manage Accountability
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.35, color: "#70839a" }}>
              Your plan, report rhythm, and agreement controls.
            </Typography>
          </Box>
        </AccordionSummary>

        <AccordionDetails sx={{ pt: 0, px: 2, pb: 2 }}>
          <Stack spacing={1.25}>
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
              {startLabel ? <Chip label={`Started ${startLabel}`} size="small" variant="outlined" /> : null}
              {endChipLabel || endLabel ? (
                <Chip label={endChipLabel || `Ends ${endLabel}`} size="small" variant="outlined" />
              ) : null}
            </Stack>

            {visionTitle ? (
              <Box>
                <Typography
                  variant="caption"
                  sx={{ color: "#8a9cb1", fontWeight: 800, letterSpacing: 0 }}
                >
                  YOUR PLAN
                </Typography>
                <Typography variant="body2" sx={{ mt: 0.35, color: "#102033", fontWeight: 700 }}>
                  {visionTitle}
                </Typography>
              </Box>
            ) : null}

            <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
              {canRenew ? (
                <Button
                  variant="outlined"
                  onClick={onRenew}
                  sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 700 }}
                >
                  {renewLabel}
                </Button>
              ) : null}
              <Button
                variant="text"
                onClick={onManageSprint}
                sx={{ alignSelf: "flex-start", px: 0, textTransform: "none", fontWeight: 800 }}
              >
                Open your plan
              </Button>
            </Stack>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} useFlexGap flexWrap="wrap">
              {canClose ? (
                <Button
                  color="warning"
                  variant="outlined"
                  onClick={onClose}
                  sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 700 }}
                >
                  Do not renew
                </Button>
              ) : null}
              <Button
                color="error"
                variant="outlined"
                onClick={onDisconnect}
                sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 700 }}
              >
                End Accountability
              </Button>
              <Button
                color="error"
                variant="text"
                onClick={onBlock}
                sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 700 }}
              >
                Block user
              </Button>
            </Stack>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Card>
  );
}
